import { render, staticRenderFns } from "./IrStatementsSearch.vue?vue&type=template&id=627eade7&"
import script from "./IrStatementsSearch.vue?vue&type=script&lang=js&"
export * from "./IrStatementsSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports